module.exports = __webpack_public_path__ + "static/media/CircularStd-BoldItalic.8bbbf07a.otf";